
export default {
  BROWSE_SEARCH_RESULTS: 'BROWSE_SEARCH_RESULTS',
  BROWSE_SEARCH_LOADING: 'BROWSE_SEARCH_LOADING',
  BROWSE_RESET_SEARCH_RESULTS: 'BROWSE_RESET_SEARCH_RESULTS',
};


// WEBPACK FOOTER //
// ./modules/browse/constants/SearchConstants.js